module.exports = __webpack_public_path__ + "img/course-creative.965ad1f3.png";